
import basicPlugins from './basic';
import inputPlugins from './input';
import selectPlugins from './select';
import complexPlugins from './complex';
import customPlugins from './custom';

export {
  basicPlugins,
  inputPlugins,
  selectPlugins,
  customPlugins,
  complexPlugins,
};

export default [...basicPlugins, ...inputPlugins, ...selectPlugins, ...complexPlugins, ...customPlugins];
